angular.module('gym.contacts').factory('NotesTags', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('tags').all('notes_all');
}]);
